import React, { useState } from 'react';
import { Box, Typography, TextField, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

import {
  reauthenticateWithCredential,
  EmailAuthProvider,
  updatePassword,
} from 'firebase/auth';

import { auth } from 'services/firebase/client';
import { styles } from './styles';
import EditBreadcrumbs from 'components/EditBreadcumbs';

const EditPassword: React.FC = () => {
  const [currentPwd, setCurrentPwd] = useState('');
  const [newPwd, setNewPwd] = useState('');
  const [confirmPwd, setConfirmPwd] = useState('');
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    setError(null);
    if (newPwd !== confirmPwd) {
      setError('A nova senha e a confirmação devem ser iguais');
      return;
    }
    if (!currentPwd) {
      setError('A senha atual é obrigatória');
      return;
    }
    if (!newPwd) {
      setError('A nova senha é obrigatória');
      return;
    }
    if (!auth.currentUser || !auth.currentUser.email) {
      setError('Usuário não autenticado');
      return;
    }

    try {
      const credential = EmailAuthProvider.credential(
        auth.currentUser.email,
        currentPwd,
      );
      await reauthenticateWithCredential(auth.currentUser, credential);

      await updatePassword(auth.currentUser, newPwd);
      navigate('/my-account');
    } catch (err: any) {
      setError('Senha atual incorreta');
    }
  };

  return (
    <Box sx={styles.container}>
      <EditBreadcrumbs current="Alterar senha" />
      <Typography variant="h5" sx={styles.title}>
        Alterar senha
      </Typography>
      <Typography sx={styles.description}>
        Para mudar sua senha, informe a atual e digite sua nova senha duas
        vezes.
      </Typography>
      <TextField
        label="Senha atual"
        type="password"
        fullWidth
        value={currentPwd}
        onChange={e => setCurrentPwd(e.target.value)}
        sx={styles.input}
      />
      <TextField
        label="Nova senha"
        type="password"
        fullWidth
        value={newPwd}
        onChange={e => setNewPwd(e.target.value)}
        sx={styles.input}
      />
      <TextField
        label="Confirmar nova senha"
        type="password"
        fullWidth
        value={confirmPwd}
        onChange={e => setConfirmPwd(e.target.value)}
        sx={styles.input}
      />
      {error && (
        <Typography color="error" sx={{ mb: 2 }}>
          {error}
        </Typography>
      )}
      <Button variant="contained" sx={styles.button} onClick={handleSubmit}>
        Salvar nova senha
      </Button>
    </Box>
  );
};

export default EditPassword;
